import React, { useEffect, useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '../components/ui/sheet';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'react-toastify';

const COMPANY_STORAGE_KEY = 'receipt-company-info';

const GenReceipt = ({ open, onClose, shipment }) => {
  const [receipt, setReceipt] = useState({
    company_name: '',
    tracking_id: '',
    company_phone: '',
    company_address: '',
    logo: '',
    sender_name: '',
    sender_address: '',
    receiver_name: '',
    receiver_address: '',
    product_name: '',
    product_description: '',
    product_price: '',
    product_weight: '',
    product_quantity: '1',
    discount: '0',
    tax: '10',
    support_mail: '',
    RecieveDate: '',
    ArrivalDate: '',
    sender_phone: '',
    receiver_phone: '',
    sender_email: '',
    receiver_email: '',
    service_type: '',
    departure_date: '',
    shipping_mode: '',
    signature: 'https://i.ibb.co/H2560nT/Michael-Jordan-personal-autograph.png',
  });

  // Load company info from localStorage and shipment data
  useEffect(() => {
    if (open && shipment) {
      // Load saved company info
      const savedCompanyInfo = localStorage.getItem(COMPANY_STORAGE_KEY);
      const companyInfo = savedCompanyInfo ? JSON.parse(savedCompanyInfo) : {};

      // Map shipment data to receipt fields
      setReceipt((prev) => ({
        ...prev,
        // Saved company info
        company_name: companyInfo.company_name || shipment.cargo_handler || '',
        company_phone: companyInfo.company_phone || '',
        company_address: companyInfo.company_address || '',
        logo: companyInfo.logo || '',
        support_mail: companyInfo.support_mail || '',
        signature: companyInfo.signature || prev.signature,
        // Shipment data
        tracking_id: shipment.tracking_id || '',
        sender_name: shipment.sender || '',
        sender_address: shipment.from || '',
        receiver_name: shipment.receiver || '',
        receiver_address: shipment.to || '',
        product_name: shipment.type_of_package || '',
        product_weight: shipment.weight_of_shipment || '',
        RecieveDate: shipment.date_and_time_recieved || '',
        ArrivalDate: shipment.estimate_delivery_date || '',
      }));
    }
  }, [open, shipment]);

  const handleChange = (e) => {
    setReceipt({
      ...receipt,
      [e.target.name]: e.target.value,
    });
  };

  const formatReceipt = (data) => {
    return `
    <!DOCTYPE html><html lang="en"><head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>${data.company_name} - Invoice</title>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900" type="text/css">
    <style>
@media print {
  @page {
    size: auto;
    margin: 0;
  }
  body {
    margin: 0;
  }
  .header, .footer {
    display: none;
  }
}
.watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${data.logo});
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.1;
  pointer-events: none;
}
.watermarkFooter {
  position: fixed;
  bottom: 60px;
  left: 1%;
  width: 400px;
  height: auto;
  opacity: 0.3;
  pointer-events: none;
}
.watermarkCross {
  position: fixed;
  bottom: 120px;
  left: 1%;
  width: 900px;
  height: auto;
  opacity: 0.3;
  pointer-events: none;
  transform: rotate(-45deg);
}
.container {
  text-align: center;
}
h1 {
  text-align: center;
  font-size: 18px;
}
.confirmation {
  font-size: 12px;
  margin-left: 0px;
}
    </style>
    </head>
    <body>
    <div class="watermark"></div>
    <div class="container-fluid invoice-container">
    <div class="container-fluid invoice-container">
      <header>
        <div class="row gy-3">
          <div class="col-12 text-center">
            <h2 class="text-4">${data.company_name} Invoice</h2>
          </div>
          <div class="col-sm-3">
            <img id="logo" width="150" src="${data.logo}" title="Logo" alt="Logo">
          </div>
          <div class="col-sm-7">
            <h4 class="text-4 mb-1">Shipment Handler: ${data.company_name}.</h4>
            <p class="lh-base mb-0"> ${data.company_name} ${data.company_address}</p>
          </div>
          <div class="col-sm-2">
            <strong>Tracking ID:</strong> ${data.tracking_id}
          </div>
        </div>
        <hr>
      </header>

      <main>
        <div class="row gy-3">
          <div class="col-sm-4">
            <p class="mb-1"><strong>Tracking ID:</strong> ${data.tracking_id}</p>
            <p class="mb-1"><strong>Recieve Date:</strong> ${data.receive_date}</p>
            <p class="mb-1"><strong>Departure Date:</strong> ${data.departure_date}</p>
            <p class="mb-1"><strong>Arrival Date:</strong> ${data.arrival_date}</p>
            <p class="mb-1"><strong>Shipping Mode:</strong> ${data.shipping_mode}</p>
            <p class="mb-1"><strong>Service Type:</strong> ${data.service_type}</p>
          </div>

          <div class="col-sm-4"> <strong>Sender:</strong>
            <address>
              <strong>Name :</strong> ${data.sender_name}<br>
              <strong>Address :</strong> ${data.sender_address}<br>
              ${data.sender_email ? `<strong>Email :</strong> ${data.sender_email}<br>` : ''}
              ${data.sender_phone ? `<strong>Phone :</strong> ${data.sender_phone}<br>` : ''}
            </address>
          </div>
          <div class="col-sm-4"> <strong>Reciever:</strong>
            <address>
              <strong>Name :</strong> ${data.receiver_name}<br>
              <strong>Address :</strong> ${data.receiver_address}<br>
              ${data.receiver_email ? `<strong>Email :</strong> ${data.receiver_email}<br>` : ''}
              ${data.receiver_phone ? `<strong>Phone :</strong> ${data.receiver_phone}<br>` : ''}
            </address>
          </div>
        </div>

        <div class="container">
          <h1>${data.shipping_mode}</h1>
          <div class="confirmation">
            <p>This confirms that ${data.company_name} has collected the shipment described below from the SENDER and agreed to deliver it to the RECIPIENT Information above. This package is transported under ${data.company_name}. This Agreement contained herein is valid, correct, and binding upon the parties. Compliance with the air waybill after its proper issuance and acceptance renders this package worthless, null, and void.</p>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table border mb-0">
            <thead>
              <tr class="bg-light">
                <td class="col-5"><strong>Product</strong></td>
                <td class="col-1 text-center"><strong>QTY</strong></td>
                <td class="col-2 text-center"><strong>Price</strong></td>
                <td class="col-2 text-center"><strong>Discount</strong></td>
                <td class="col-2 text-end"><strong>Total</strong></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="col-5">
                  ${data.product_name}
                  <p class="text-0 text-black-50 lh-base mb-0">${data.product_description}</p>
                  <p class="text-1 mb-0">Insured</p>
                </td>
                <td class="col-1 text-center">${data.product_quantity}</td>
                <td class="col-2 text-center">$${data.product_price * data.product_weight}</td>
                <td class="col-2 text-center">$${data.discount}</td>
                <td class="col-2 text-end">$${data.product_price * data.product_weight - data.discount}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive">
          <table class="table border border-top-0 mb-0">
            <tbody>
              <tr class="bg-light">
                <td class="text-end"><strong>Sub Total:</strong></td>
                <td class="col-sm-2 text-end">$${data.product_price * data.product_weight}</td>
              </tr>
              <tr class="bg-light">
                <td class="text-end"><strong>Tax:</strong></td>
                <td class="col-sm-2 text-end">$${(data.product_price * data.product_weight) * (data.tax / 100)}</td>
              </tr>
              <tr class="bg-light">
                <td class="text-end"><strong>Grand Total:</strong></td>
                <td class="col-sm-2 text-end">$${((data.product_price * data.product_weight) * (data.tax / 100) + (data.product_price * data.product_weight) - data.discount).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>

      <footer class="mt-5">
        <img width="450" class="watermarkFooter" src="https://i.ibb.co/FWSZfyK/paidwater-removebg-preview.png">
        <img width="450" class="watermarkCross" src="https://i.ibb.co/cCL2GCL/2.png">
        <div class="text-end mb-4">
          <img id="logo" width="150" src="${data.signature}" title="Signature" alt="Signature"><br>
          <div class="lh-1 text-black-50">Thank You!</div>
          <div class="lh-1 text-black-50 text-0"><small>For your patronage</small></div>
        </div>
        <p class="text-0 mb-0"><strong>NOTE::</strong> Local charges are the responsibility of the receiver, and a demurrage fee will be incurred if these charges are not paid within three days.</p>
        <p class="text-center">Helpline:${data.support_mail}</p>
        <div class="text-center">
          <div class="btn-group btn-group-sm d-print-none">
            <a href="javascript:window.print()" class="btn btn-light border text-black-50 shadow-none"><i class="fa fa-print"></i> Print & Download</a>
          </div>
        </div>
      </footer>
    </div>
    </body></html>`;
  };

  const getCSS = () => {
    // Bootstrap 5 CSS (minified version for invoice styling)
    return `
:root{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-black:#000;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40}
*,::after,::before{box-sizing:border-box}
body{margin:0;font-family:Poppins,system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;background-color:#fff}
.container,.container-fluid{width:100%;padding-right:var(--bs-gutter-x,.75rem);padding-left:var(--bs-gutter-x,.75rem);margin-right:auto;margin-left:auto}
.row{display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}
.row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}
.col-1{flex:0 0 auto;width:8.33333333%}
.col-2{flex:0 0 auto;width:16.66666667%}
.col-4{flex:0 0 auto;width:33.33333333%}
.col-5{flex:0 0 auto;width:41.66666667%}
.col-12{flex:0 0 auto;width:100%}
@media (min-width:576px){.col-sm-2{flex:0 0 auto;width:16.66666667%}.col-sm-3{flex:0 0 auto;width:25%}.col-sm-4{flex:0 0 auto;width:33.33333333%}.col-sm-7{flex:0 0 auto;width:58.33333333%}}
.gy-3{--bs-gutter-y:1rem}
.table{width:100%;margin-bottom:1rem;color:#212529;vertical-align:top;border-color:#dee2e6}
.table>:not(caption)>*>*{padding:.5rem .5rem;background-color:var(--bs-table-bg);border-bottom-width:1px;box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}
.table>tbody{vertical-align:inherit}
.table>thead{vertical-align:bottom}
.table-responsive{overflow-x:auto;-webkit-overflow-scrolling:touch}
.border{border:1px solid #dee2e6!important}
.border-top-0{border-top:0!important}
.text-center{text-align:center!important}
.text-end{text-align:right!important}
.bg-light{background-color:#f8f9fa!important}
.mb-0{margin-bottom:0!important}
.mb-1{margin-bottom:.25rem!important}
.mb-4{margin-bottom:1.5rem!important}
.mt-5{margin-top:3rem!important}
.lh-1{line-height:1!important}
.lh-base{line-height:1.5!important}
h1,h2,h4{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2}
h2{font-size:calc(1.325rem + .9vw)}
h4{font-size:calc(1.275rem + .3vw)}
p{margin-top:0;margin-bottom:1rem}
address{margin-bottom:1rem;font-style:normal;line-height:inherit}
hr{margin:1rem 0;color:inherit;border:0;border-top:1px solid;opacity:.25}
img{vertical-align:middle}
.text-4{font-size:1.25rem!important}
.text-0{font-size:.6875rem!important}
.text-1{font-size:.75rem!important}
.text-black-50{color:rgba(0,0,0,.5)!important}
.btn{display:inline-block;font-weight:400;line-height:1.5;color:#212529;text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;border-radius:.375rem}
.btn-light{color:#000;background-color:#f8f9fa;border-color:#f8f9fa}
.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;border-radius:.25rem}
.invoice-container{max-width:800px;background:#fff;margin:20px auto;padding:30px;box-shadow:0 0 10px rgba(0,0,0,.1)}
@media print{.d-print-none{display:none!important}}
    `;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Save company info to localStorage
    const companyInfo = {
      company_name: receipt.company_name,
      company_phone: receipt.company_phone,
      company_address: receipt.company_address,
      logo: receipt.logo,
      support_mail: receipt.support_mail,
      signature: receipt.signature,
    };
    localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(companyInfo));

    // Prepare data for receipt
    const data = {
      company_name: receipt.company_name,
      tracking_id: receipt.tracking_id,
      company_phone: receipt.company_phone,
      company_address: receipt.company_address,
      logo: receipt.logo,
      sender_name: receipt.sender_name,
      sender_address: receipt.sender_address,
      receiver_name: receipt.receiver_name,
      receiver_address: receipt.receiver_address,
      product_name: receipt.product_name,
      product_description: receipt.product_description,
      product_price: parseFloat(receipt.product_price) || 0,
      product_weight: parseFloat(receipt.product_weight) || 0,
      product_quantity: parseInt(receipt.product_quantity) || 1,
      discount: parseFloat(receipt.discount) || 0,
      tax: parseFloat(receipt.tax) || 10,
      support_mail: receipt.support_mail,
      signature: receipt.signature,
      receive_date: receipt.RecieveDate,
      arrival_date: receipt.ArrivalDate,
      sender_phone: receipt.sender_phone,
      receiver_phone: receipt.receiver_phone,
      sender_email: receipt.sender_email,
      receiver_email: receipt.receiver_email,
      service_type: receipt.service_type,
      departure_date: receipt.departure_date,
      shipping_mode: receipt.shipping_mode,
    };

    const body = formatReceipt(data);
    const css = getCSS();

    const newTab = window.open();
    newTab.document.open();
    newTab.document.write(`
      <html>
        <head>
          <style>${css}</style>
        </head>
        <body>${body}</body>
      </html>
    `);
    newTab.document.close();

    toast.success('Receipt generated!', { theme: 'dark', position: 'bottom-center' });
    onClose();
  };

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto bg-white text-gray-900 border-gray-200">
        <SheetHeader>
          <SheetTitle className="text-gray-900">Generate Receipt</SheetTitle>
          <SheetDescription className="text-gray-500">
            Fill in the details below. Company info will be saved for future use.
          </SheetDescription>
        </SheetHeader>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {/* Company Info Section */}
          <div className="space-y-3 p-3 bg-blue-50 rounded-lg border border-blue-100">
            <h3 className="text-sm font-semibold text-[#2B5DF5]">Company Info (Saved)</h3>

            <div className="grid gap-2">
              <Label htmlFor="company_name" className="text-gray-700">Company Name</Label>
              <Input
                id="company_name"
                name="company_name"
                value={receipt.company_name}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="company_phone" className="text-gray-700">Company Phone</Label>
              <Input
                id="company_phone"
                name="company_phone"
                value={receipt.company_phone}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="company_address" className="text-gray-700">Company Address</Label>
              <Input
                id="company_address"
                name="company_address"
                value={receipt.company_address}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="logo" className="text-gray-700">Logo URL</Label>
              <Input
                id="logo"
                name="logo"
                value={receipt.logo}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="support_mail" className="text-gray-700">Support Email</Label>
              <Input
                id="support_mail"
                name="support_mail"
                value={receipt.support_mail}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="signature" className="text-gray-700">Signature URL</Label>
              <Input
                id="signature"
                name="signature"
                value={receipt.signature}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>
          </div>

          {/* Shipment Info Section (Auto-filled) */}
          <div className="space-y-3 p-3 bg-green-50 rounded-lg border border-green-100">
            <h3 className="text-sm font-semibold text-green-600">Shipment Info (Auto-filled)</h3>

            <div className="grid gap-2">
              <Label htmlFor="tracking_id" className="text-gray-700">Tracking ID</Label>
              <Input
                id="tracking_id"
                name="tracking_id"
                value={receipt.tracking_id}
                onChange={handleChange}
                className="bg-gray-100 border-gray-300 text-gray-900"
                readOnly
              />
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="sender_name" className="text-gray-700">Sender Name</Label>
                <Input
                  id="sender_name"
                  name="sender_name"
                  value={receipt.sender_name}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="receiver_name" className="text-gray-700">Receiver Name</Label>
                <Input
                  id="receiver_name"
                  name="receiver_name"
                  value={receipt.receiver_name}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="sender_address" className="text-gray-700">Sender Address</Label>
                <Input
                  id="sender_address"
                  name="sender_address"
                  value={receipt.sender_address}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="receiver_address" className="text-gray-700">Receiver Address</Label>
                <Input
                  id="receiver_address"
                  name="receiver_address"
                  value={receipt.receiver_address}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="RecieveDate" className="text-gray-700">Receive Date</Label>
                <Input
                  id="RecieveDate"
                  name="RecieveDate"
                  value={receipt.RecieveDate}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="ArrivalDate" className="text-gray-700">Arrival Date</Label>
                <Input
                  id="ArrivalDate"
                  name="ArrivalDate"
                  value={receipt.ArrivalDate}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="space-y-3 p-3 bg-yellow-50 rounded-lg border border-yellow-100">
            <h3 className="text-sm font-semibold text-yellow-600">Contact Info</h3>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="sender_phone" className="text-gray-700">Sender Phone</Label>
                <Input
                  id="sender_phone"
                  name="sender_phone"
                  value={receipt.sender_phone}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="receiver_phone" className="text-gray-700">Receiver Phone</Label>
                <Input
                  id="receiver_phone"
                  name="receiver_phone"
                  value={receipt.receiver_phone}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="sender_email" className="text-gray-700">Sender Email</Label>
                <Input
                  id="sender_email"
                  name="sender_email"
                  value={receipt.sender_email}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="receiver_email" className="text-gray-700">Receiver Email</Label>
                <Input
                  id="receiver_email"
                  name="receiver_email"
                  value={receipt.receiver_email}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>
          </div>

          {/* Product Info Section */}
          <div className="space-y-3 p-3 bg-orange-50 rounded-lg border border-orange-100">
            <h3 className="text-sm font-semibold text-orange-600">Product Info</h3>

            <div className="grid gap-2">
              <Label htmlFor="product_name" className="text-gray-700">Package Type</Label>
              <Input
                id="product_name"
                name="product_name"
                value={receipt.product_name}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="product_description" className="text-gray-700">Product Description</Label>
              <Input
                id="product_description"
                name="product_description"
                value={receipt.product_description}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>

            <div className="grid grid-cols-3 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="product_price" className="text-gray-700">Price/KG ($)</Label>
                <Input
                  id="product_price"
                  name="product_price"
                  type="number"
                  value={receipt.product_price}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="product_weight" className="text-gray-700">Weight (KG)</Label>
                <Input
                  id="product_weight"
                  name="product_weight"
                  type="number"
                  value={receipt.product_weight}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="product_quantity" className="text-gray-700">Quantity</Label>
                <Input
                  id="product_quantity"
                  name="product_quantity"
                  type="number"
                  value={receipt.product_quantity}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="discount" className="text-gray-700">Discount ($)</Label>
                <Input
                  id="discount"
                  name="discount"
                  type="number"
                  value={receipt.discount}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="tax" className="text-gray-700">Tax (%)</Label>
                <Input
                  id="tax"
                  name="tax"
                  type="number"
                  value={receipt.tax}
                  onChange={handleChange}
                  className="bg-white border-gray-300 text-gray-900"
                />
              </div>
            </div>
          </div>

          {/* Shipping Info Section */}
          <div className="space-y-3 p-3 bg-purple-50 rounded-lg border border-purple-100">
            <h3 className="text-sm font-semibold text-purple-600">Shipping Info</h3>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="service_type" className="text-gray-700">Service Type</Label>
                <Input
                  id="service_type"
                  name="service_type"
                  value={receipt.service_type}
                  onChange={handleChange}
                  placeholder="e.g., Express, Standard"
                  className="bg-white border-gray-300 text-gray-900 placeholder-gray-400"
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="shipping_mode" className="text-gray-700">Shipping Mode</Label>
                <Input
                  id="shipping_mode"
                  name="shipping_mode"
                  value={receipt.shipping_mode}
                  onChange={handleChange}
                  placeholder="e.g., Air, Sea, Land"
                  className="bg-white border-gray-300 text-gray-900 placeholder-gray-400"
                />
              </div>
            </div>

            <div className="grid gap-2">
              <Label htmlFor="departure_date" className="text-gray-700">Departure Date</Label>
              <Input
                id="departure_date"
                name="departure_date"
                value={receipt.departure_date}
                onChange={handleChange}
                className="bg-white border-gray-300 text-gray-900"
              />
            </div>
          </div>

          <Button type="submit" className="w-full bg-[#2B5DF5] hover:bg-[#1E4BD4] text-white shadow-sm">
            Generate Receipt
          </Button>
        </form>
      </SheetContent>
    </Sheet>
  );
};

export default GenReceipt;
